(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-commerce-refinements"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-open-dialog]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.openDialog);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = '';
        opener.focus({preventScroll:true});
      }, {once:true});
    }
  }
  const closer = event.target.closest('[data-close-dialog]');
  if (closer) closer.closest('dialog')?.close();
  const edit = event.target.closest('[data-edit-options]');
  if (edit) {
    const options = edit.closest('fh-product')?.querySelector('[data-variant-ui]');
    options?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    options?.focus({preventScroll:true});
  }
});
document.querySelectorAll('.fh-dialog').forEach(dialog => {
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
});
if (!customElements.get('fh-fit-picker')) {
  customElements.define('fh-fit-picker', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      this.addEventListener('click', event => {
        if(event.target.closest('[data-fit-calculate]')) this.calculate();
        const select=event.target.closest('[data-fit-select]');
        if(select) {
          const product=this.closest('fh-product');
          const radio=product?.querySelector('[name="fh-size"][value="'+select.dataset.fitSelect+'"]');
          if(radio) { radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));this.closest('dialog').close(); }
        }
      });
      this.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('[data-fit-measure]')){event.preventDefault();this.calculate();}});
      this.querySelector('[data-fit-unit]').addEventListener('change',event=>{
        const inches=event.target.value==='in';
        const input=this.querySelector('[data-fit-measure]');
        if(input.value) input.value=(Number(input.value)*(inches?1/2.54:2.54)).toFixed(1);
        this.querySelectorAll('[data-chart-cm]').forEach(n=>n.hidden=inches);
        this.querySelectorAll('[data-chart-in]').forEach(n=>n.hidden=!inches);
        if(input.value)this.calculate();
      });
    }
    calculate() {
      const input=this.querySelector('[data-fit-measure]');
      const value=Number(input.value);
      const output=this.querySelector('[data-fit-result]');
      this.querySelectorAll('[data-fit-row]').forEach(row=>row.removeAttribute('data-match'));
      if(!input.value||!Number.isFinite(value)||value<=0){output.textContent=this.dataset.error;return;}
      const cm=this.querySelector('[data-fit-unit]').value==='in'?value*2.54:value;
      const ranges=[['XXS',30,38],['XS',38,46],['S',45,57],['M',56,68],['L',67,82],['XL',80,92]];
      const matches=ranges.filter(([,min,max])=>cm>=min&&cm<=max).map(([size])=>size);
      output.textContent=matches.length?this.dataset.result+' '+matches.join(' / '):this.dataset.none;
      this.querySelectorAll('[data-fit-row]').forEach(row=>row.dataset.match=String(matches.includes(row.dataset.fitRow)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-harness-advertorial"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.fh-shop-landing a[href*="/products/"]').forEach((link) => {
  const target = new URL(link.href, window.location.origin);
  const current = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach((key) => {
    if (current.has(key)) target.searchParams.set(key, current.get(key));
  });
  target.searchParams.set('landing_source', document.querySelector('[data-campaign]')?.dataset.campaign || 'campaign');
  link.href = target.toString();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-harness-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-product')) {
 customElements.define('fh-product', class extends HTMLElement {
  connectedCallback() {
   if(this.ready) return;
   const data=this.querySelector('[data-variants]'); if(!data) return;
   this.ready=true; this.variants=JSON.parse(data.textContent);
   this.native=this.querySelector('select[name="id"]');
   this.native.required=false;
   this.querySelector('[data-native-variant]').hidden=true;
   this.querySelector('[data-variant-ui]').hidden=false;
   const linkedId=new URL(window.location.href).searchParams.get('variant');
   const linked=this.variants.find(v=>String(v.id)===linkedId);
   this.querySelectorAll('[name="fh-size"]').forEach(input=>input.checked=Boolean(linked&&input.value===linked.options[1]));
   if(linked)this.querySelectorAll('[name="fh-color"]').forEach(input=>input.checked=input.value===linked.options[0]);
   this.addEventListener('change',e=>{if(e.target.matches('input[type="radio"]'))this.sync(true,e.target.name==='fh-color');});
   this.addEventListener('click',e=>{const control=e.target.closest('[data-gallery]');if(control)this.showSlide(control.dataset.gallery);});
   this.querySelector('form').addEventListener('submit',e=>{
    if(this.native.value)return;
    e.preventDefault();
    const warning=this.querySelector('[data-size-warning]');if(warning)warning.hidden=false;
    const sizes=this.querySelector('[data-size-group]');sizes?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});sizes?.focus({preventScroll:true});
   });
   const stage=this.querySelector('[data-swipe-gallery]');
   if(stage){let startX=0,startY=0;stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY;},{passive:true});stage.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)<45||Math.abs(dx)<Math.abs(dy))return;const buttons=[...this.querySelectorAll('[data-gallery]')];if(!buttons.length)return;const i=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');const next=(i+(dx<0?1:-1)+buttons.length)%buttons.length;this.showSlide(buttons[next].dataset.gallery);},{passive:true});}
   this.sync(false,Boolean(linked));
   const sticky=this.querySelector('.fh-sticky');const target=this.querySelector('.fh-add');
   if(sticky&&target&&'IntersectionObserver' in window){this.observer=new IntersectionObserver(([entry])=>{sticky.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;},{threshold:0});this.observer.observe(target);}
  }
  showSlide(name){this.querySelectorAll('[data-slide]').forEach(s=>s.hidden=s.dataset.slide!==name);this.querySelectorAll('[data-gallery]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.gallery===name)));}
  sync(updateUrl,photoChange){
   const color=this.querySelector('[name="fh-color"]:checked');const size=this.querySelector('[name="fh-size"]:checked');if(!color)return;
   const variant=size?this.variants.find(v=>v.options[0]===color.value&&v.options[1]===size.value):null;
   const display=variant||this.variants.find(v=>v.options[0]===color.value&&v.available)||this.variants.find(v=>v.options[0]===color.value);
   this.querySelector('[data-color-label]').textContent=color.value;
   this.querySelector('[data-size-label]').textContent=size?size.value:this.dataset.chooseLabel;
   this.querySelector('[data-current-fit]').textContent=size?size.dataset.range:this.dataset.fitPrompt;
   const prefix=this.querySelector('[data-fit-prefix]');if(prefix)prefix.hidden=!size;
   this.native.value=variant?String(variant.id):'';
   const enabled=size?Boolean(variant?.available):this.variants.some(v=>v.options[0]===color.value&&v.available);
   const label=enabled?(size?this.dataset.addLabel:this.dataset.chooseLabel):this.dataset.soldLabel;
   this.querySelectorAll('.fh-add,[data-sticky-add]').forEach(b=>b.disabled=!enabled);
   this.querySelector('[data-add-text]').textContent=label;
   const stickyAdd=this.querySelector('[data-sticky-add]');if(stickyAdd)stickyAdd.textContent=label+' →';
   const stickySelection=this.querySelector('[data-sticky-selection]');if(stickySelection)stickySelection.textContent=color.value+' / '+(size?size.value:this.dataset.chooseLabel);
   const warning=this.querySelector('[data-size-warning]');if(variant&&warning)warning.hidden=true;
   this.querySelectorAll('[data-fit-select]').forEach(button=>{button.disabled=!this.variants.some(v=>v.options[0]===color.value&&v.options[1]===button.dataset.fitSelect&&v.available);});
   this.querySelectorAll('[name="fh-size"]').forEach(input=>{input.disabled=!this.variants.some(v=>v.options[0]===color.value&&v.options[1]===input.value&&v.available);});
   if(display){
    this.querySelector('[data-price]').textContent=display.price;
    const stickyPrice=this.querySelector('[data-sticky-price]');if(stickyPrice)stickyPrice.textContent=display.price;
    const compare=this.querySelector('[data-compare]');compare.hidden=!display.compare;compare.textContent=display.compare||'';
    const sale=this.querySelector('[data-sale]');sale.hidden=!display.sale;sale.textContent=display.sale||'';
    const launch=this.querySelector('[data-launch]');if(launch)launch.hidden=Boolean(display.compare);
   }
   if(photoChange){
    const img=this.querySelector('[data-product-photo]');
    const photoUrl=width=>{const url=new URL(color.dataset.colorPhoto,window.location.origin);url.searchParams.set('width',width);return url.href;};
    if(img){img.srcset=[360,540,720,960,1200].map(width=>photoUrl(width)+' '+width+'w').join(', ');img.src=photoUrl(1200);img.alt='FurSwift '+color.value+' harness';}
    const thumb=this.querySelector('[data-product-thumb]');if(thumb){thumb.srcset=[120,240].map(width=>photoUrl(width)+' '+width+'w').join(', ');thumb.src=photoUrl(240);}
    const photoLabel=this.querySelector('[data-photo-color]');if(photoLabel)photoLabel.textContent=color.value;
    if(this.querySelector('[data-gallery="product"]'))this.showSlide('product');
   }
   if(updateUrl){const u=new URL(window.location.href);if(variant)u.searchParams.set('variant',variant.id);else u.searchParams.delete('variant');history.replaceState({},'',u);}
  }
  disconnectedCallback(){this.observer?.disconnect();}
 });
}
if (!customElements.get('fh-tabs')) {
 customElements.define('fh-tabs',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.tabs=[...this.querySelectorAll('[role="tab"]')];
   this.addEventListener('click',e=>{const t=e.target.closest('[role="tab"]');if(t)this.selectTab(t);});
   this.addEventListener('keydown',e=>{if(!e.target.matches('[role="tab"]'))return;const i=this.tabs.indexOf(e.target);let n;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(i+this.tabs.length-1)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();this.selectTab(this.tabs[n]);this.tabs[n].focus();});
  }
  selectTab(tab){this.tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;const p=this.querySelector('#'+t.getAttribute('aria-controls'));if(p)p.hidden=!active;});}
 });
}
if (!customElements.get('fh-fit-guide')) {
 customElements.define('fh-fit-guide',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.unit='cm';this.addEventListener('click',e=>{const b=e.target.closest('[data-unit]');if(b){this.changeUnit(b.dataset.unit);return;}if(e.target.closest('[data-find-size]'))this.findSize();});this.querySelector('input')?.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();this.findSize();}});}
  changeUnit(unit){if(unit===this.unit)return;const input=this.querySelector('input');if(input&&input.value){const n=Number(input.value);if(Number.isFinite(n))input.value=(unit==='cm'?n*2.54:n/2.54).toFixed(1);}this.unit=unit;this.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.unit===unit)));this.querySelectorAll('[data-cm]').forEach(n=>n.hidden=unit!=='cm');this.querySelectorAll('[data-in]').forEach(n=>n.hidden=unit!=='in');const label=this.querySelector('[data-current-unit]');if(label)label.textContent=unit;if(input?.value)this.findSize();}
  findSize(){const input=this.querySelector('input');const out=this.querySelector('[data-fit-output]');if(!input||!out)return;const value=Number(input.value);if(!input.value||!Number.isFinite(value)||value<=0){out.textContent=out.dataset.error;return;}const cm=this.unit==='in'?value*2.54:value;const ranges=[['XXS',30,38],['XS',38,46],['S',45,57],['M',56,68],['L',67,82],['XL',80,92]];const sizes=ranges.filter(([,a,b])=>cm>=a&&cm<=b).map(r=>r[0]);out.textContent=sizes.length?out.dataset.result+' '+sizes.join(' / '):out.dataset.none;}
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-harness-features"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fh-feature-carousel'))customElements.define('fh-feature-carousel',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.track=this.querySelector('.fh-feature-track');this.prev=this.querySelector('[data-feature-prev]');this.next=this.querySelector('[data-feature-next]');
  this.querySelectorAll('.fh-feature-tile').forEach(tile=>{
   const button=tile.querySelector('.fh-feature-reveal');
   tile.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'||e.pointerType==='pen'){tile.hovered=true;this.reveal(button,true);}});
   tile.addEventListener('pointerleave',()=>{tile.hovered=false;if(!button.matches(':focus-visible'))this.reveal(button,false);});
   button.addEventListener('focus',()=>{if(button.matches(':focus-visible'))this.reveal(button,true);});
   button.addEventListener('blur',()=>{if(!tile.hovered)this.reveal(button,false);});
   button.addEventListener('click',()=>{if(tile.hovered)this.reveal(button,true);else this.reveal(button,button.getAttribute('aria-expanded')!=='true');});
   button.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();this.reveal(button,false);}});
  });
  const update=()=>{this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-3;};
  this.prev.addEventListener('click',()=>this.move(-1));this.next.addEventListener('click',()=>this.move(1));
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1);}});
  this.track.addEventListener('scroll',update,{passive:true});this.observer=new ResizeObserver(update);this.observer.observe(this.track);update();
 }
 reveal(button,open){button.setAttribute('aria-expanded',String(open));this.querySelector('#'+button.getAttribute('aria-controls')).hidden=!open;}
 move(direction){const card=this.querySelector('.fh-feature-card');this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-paw-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fp-paw-gallery')) {
  customElements.define('fp-paw-gallery', class extends HTMLElement {
    constructor() {
      super();
      this.selectSlide = this.selectSlide.bind(this);
    }
    connectedCallback() { this.addEventListener('click', this.selectSlide); }
    disconnectedCallback() { this.removeEventListener('click', this.selectSlide); }
    selectSlide(event) {
      const button = event.target.closest('button[data-slide]');
      if (!button || !this.contains(button)) return;
      const selected = button.dataset.slide;
      this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== selected; });
      this.querySelectorAll('button[data-slide]').forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb.dataset.slide === selected)); });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-studio-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('studio-gallery'))customElements.define('studio-gallery',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.buttons=[...this.querySelectorAll('button[data-panel]')];this.current=0;this.addEventListener('click',e=>{const button=e.target.closest('button[data-panel]');const step=e.target.closest('button[data-gallery-step]');if(button)this.show(this.buttons.indexOf(button));if(step)this.show(this.current+Number(step.dataset.galleryStep));});this.addEventListener('keydown',e=>{if(!e.target.matches('button[data-panel]'))return;let next=this.current;if(e.key==='ArrowRight')next++;else if(e.key==='ArrowLeft')next--;else if(e.key==='Home')next=0;else if(e.key==='End')next=this.buttons.length-1;else return;e.preventDefault();this.show(next);this.buttons[this.current].focus();});}
 show(index){this.current=(index+this.buttons.length)%this.buttons.length;const button=this.buttons[this.current];this.querySelectorAll('[data-gallery-panel]').forEach(panel=>panel.hidden=panel.dataset.galleryPanel!==button.dataset.panel);this.buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelector('[data-gallery-caption]').textContent=button.dataset.caption;this.querySelector('[data-gallery-counter]').textContent=`${this.current+1} / ${this.buttons.length}`;}
});
  } catch(e) { console.error(e); }
})();

})();
